import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.job.search.sortFields,
	columnFields: constants.job.search.columnFields,
	standardFilterFields: constants.job.search.standardFilterFields,
	dateFilterFields: constants.job.search.dateFilterFields,
	stageStatusFilterFields: constants.job.search.stageStatusFilterFields,
	booleanFilterFields: [] as const,
});
